import type { ImageManipulationFilter } from '@/modules/Editor/imageManipulation'
import { WINDOW_LEVEL_RANGE_UNITS } from '@/modules/Editor/imageManipulation'
import { getNumPixelChannels } from '@/modules/Editor/utils/windowLevels'
import { unscaleWindowLevelRange } from '@/modules/Editor/utils/radiology/scaleWindowLevelRange'
import type { ExtendedFileMetadata } from '@/modules/Editor/metadata'

export const setActiveManipulationPreset = (
  activeView: {
    setImageFilter: (filter: ImageManipulationFilter) => void
    fileManager: { file: { metadata?: ExtendedFileMetadata } }
  },
  manipulation: ImageManipulationFilter,
  units?: WINDOW_LEVEL_RANGE_UNITS,
): void => {
  let windowLevelRange = manipulation.windowLevels

  if (units === WINDOW_LEVEL_RANGE_UNITS.HOUNSFIELD) {
    // Convert the window level units

    const fileMetadata = activeView.fileManager.file.metadata
    const medicalMetadata = fileMetadata?.medical
    const numPixelChannels = getNumPixelChannels(fileMetadata?.colorspace)

    windowLevelRange = unscaleWindowLevelRange(windowLevelRange, numPixelChannels, medicalMetadata)
  }

  activeView.setImageFilter({ ...manipulation, windowLevels: windowLevelRange })
}
